/**
 * Base type for all report blocks
 *
 * Encapsulates block logic with validation and business rules.
 * Immutable by design to ensure data integrity.
 *
 * All report blocks share these fundamental properties:
 * - key: Unique value for the block
 * - endpoint: API endpoint to fetch block data
 *
 * @example
 * const blockBase = createBlockBase({
 *   key: 'summary_table',
 *   endpoint: 'api/v1/sales/summary',
 * });
 */
export type BlockBase = Readonly<{
  key: string;
  endpoint: string;
}>;

/**
 * Validate that a block is valid
 *
 * @param block - The block to validate
 * @throws {Error} If the block is invalid
 */
export const validateBlockBase = (block: BlockBase): void => {
  if (!block.endpoint || block.endpoint.trim().length === 0) {
    throw new Error('Block endpoint is required');
  }

  if (!block.key || block.key.trim().length === 0) {
    throw new Error('Block key is required');
  }
};
